import React from 'react'
import './index.less'

const Index = ()=>{
  return (
  <div className="page-footer">
      <div className="footer-logo">
        <img className="pingan_logo" src={require("../../image/pingan-logo@2x.png")} title="中国平安" />
        <img className="cx_logo" src={require("../../image/cx-logo.png")} title="中国平安财产保险" />
      </div>
      <p>版权所有 © 中国平安保险（集团）股份有限公司 未经许可不得复制、转载或摘编，违者必究!</p>
      <p>Copyright © Ping an insurance (group) company of china ,LTD. all rights reserved</p>
      <p className="page-footer-dis_inline">ICP许可证号 粤ICP备06118290号-7</p>
      <div className="page-footer-copyright_por page-footer-dis_inline">
        <a target="_blank" href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402000932" rel="noopener noreferrer">
          <img src="//pimg1.4008000000.com/app_images/baoxian/v10/por_icon.png" className="page-footer-fl" alt="粤公网安备"/>
          <p>粤公网安备 44030402000932号</p>
        </a>
      </div>
    </div>
  )
}

export default Index